import { useEffect } from 'react';
import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import ProductIncomeEditButton from './ProductIncomeActions/ProductIncomeEditButton';
import ProductIncomeDeleteButton from './ProductIncomeActions/ProductIncomeDeleteButton';
import { defaultExtendedValue } from './utils';
import {
  checkIncomeCategoryNameCompleted,
  filterAndSortBySubgroup,
} from '../utils';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';
import ProductIncomeYearFieldsForm from './ProductIncomeYearFieldsForm';

const ProductIncomeExtendedForm = () => {
  const { watch, setValue } = useNatureOfBusinessForm();
  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const productIncomeItems = incomeStructure?.productIncomeItems || {};
  const productIncomeExtended = filterAndSortBySubgroup(
    productIncomeItems,
    INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME
  );

  useEffect(() => {
    if (productIncomeExtended.length === 0) {
      setValue(
        `incomeStructure.productIncomeItems.${INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME}-1`,
        defaultExtendedValue
      );
      setValue(
        `incomeStructure.productIncomePercentages.${INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME}-1`,
        defaultExtendedValue
      );
    }
  }, []);

  return (
    <>
      {productIncomeExtended.map(([key, item], index) => (
        <Flex key={key} width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350} justifyItems={'end'}>
            <InputLabel
              sx={{
                textAlign: 'right',
                color: checkIncomeCategoryNameCompleted(item.incomeCategory)
                  ? 'inherit'
                  : 'error.main',
              }}
              required
            >
              {item.incomeCategory?.nameTh && item.incomeCategory?.nameTh !== ''
                ? item.incomeCategory?.nameTh
                : 'กรุณาระบุสายผลิตภัณฑ์หรือกลุ่มธุรกิจ'}
            </InputLabel>
            <Flex alignItems={'center'}>
              <Typography textAlign={'right'} color={'text.secondary'}>
                (พันบาท)
              </Typography>
              <ProductIncomeEditButton keyItem={key} />
              {index !== 0 && <ProductIncomeDeleteButton keyItem={key} />}
            </Flex>
          </Box>
          <ProductIncomeYearFieldsForm keyItem={key} />
        </Flex>
      ))}
    </>
  );
};

export default ProductIncomeExtendedForm;
